module.exports = __webpack_public_path__ + "img/exclaimation.faa95219.svg";